import { useEffect } from 'react'

import { Box, TextField } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { ROUTE_PATHS } from 'routes'

function StripeSuccessPage(): JSX.Element {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	useEffect(() => {
		// Extract success information from URL params
		const sessionId = searchParams.get('session_id')
		const subscriptionId = searchParams.get('subscription_id')

		// Create success message
		const message = 'Payment setup completed successfully!'

		// Redirect to account settings with success notification
		navigate(ROUTE_PATHS.ACCOUNT.SETTINGS, {
			state: {
				notification: {
					type: 'success',
					message: message,
					title: 'Payment Successful',
					sessionId: sessionId,
					subscriptionId: subscriptionId,
				},
			},
		})
	}, [navigate, searchParams])

	// Return a loading state while redirecting
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				gap: '16px',
			}}
		>
			<Box
				sx={{
					width: '50px',
					height: '50px',
					border: '3px solid #f3f3f3',
					borderTop: '3px solid #4CAF50',
					borderRadius: '50%',
					animation: 'spin 1s linear infinite',
				}}
			/>
			<TextField
				sx={{ color: '#4CAF50', fontSize: '18px', fontWeight: 'bold' }}
				value="Payment Successful! Redirecting..."
				InputProps={{
					readOnly: true,
					style: { textAlign: 'center' },
				}}
			/>
			<style>
				{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
			</style>
		</Box>
	)
}

export default StripeSuccessPage
